var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerServiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "87px",
    viewBox: "0 0 81 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "customer-service-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "catalogue-desktop",
    transform: "translate(-1169.000000, -1616.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customer-service-icon",
    transform: "translate(1169.000000, 1616.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-Copy-2",
    fill: "#000000",
    transform: "translate(68.000000, 72.500000) scale(-1, 1) rotate(-90.000000) translate(-68.000000, -72.500000) ",
    points: "68 65 82 80 54 80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#000000",
    x: 27,
    y: 19,
    width: 54,
    height: 54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#000000",
    transform: "translate(12.000000, 53.500000) rotate(-90.000000) translate(-12.000000, -53.500000) ",
    points: "12 46 26 61 -2 61"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#ECEAE8",
    cx: 9.5,
    cy: 26.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#ECEAE8",
    cx: 21.5,
    cy: 26.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#ECEAE8",
    cx: 33.5,
    cy: 26.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#ECEAE8",
    cx: 45.5,
    cy: 26.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.9,
    y1: 19,
    x2: 55,
    y2: 53,
    id: "Line",
    stroke: "#ECEAE8",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.5,
    y1: 55,
    x2: 55,
    y2: 55,
    id: "Line-2",
    stroke: "#ECEAE8",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerServiceIcon);
export default __webpack_public_path__ + "static/media/customer-service-icon.73c438a9a3f172070194de7951c06c13.svg";
export { ForwardRef as ReactComponent };